import React, { useEffect, useState } from 'react';
import api from './api';
import { userDisplayName, timeAgo } from './helpers';

const ICONE = {
  creation: '➕',
  modification: '✏️',
  suppression: '🗑️',
  commentaire: '💬',
  document: '📎',
};

const LIBELLE = {
  creation: 'a créé',
  modification: 'a modifié',
  suppression: 'a supprimé',
  commentaire: 'a commenté',
  document: 'a ajouté un document à',
};

function ActivityLog({ projectId, users }) {
  const [lignes, setLignes] = useState([]);
  const [chargement, setChargement] = useState(true);

  useEffect(() => {
    api
      .get('/activity', { params: { projectId, limit: 200 } })
      .then((res) => setLignes(res.data))
      .catch(() => setLignes([]))
      .finally(() => setChargement(false));
  }, [projectId]);

  if (chargement) return <p>Chargement...</p>;

  if (lignes.length === 0) {
    return (
      <div className="empty-state">
        Aucune activité enregistrée pour ce projet.
        <div style={{ fontSize: 12.5, marginTop: 6 }}>
          Le journal se remplit à partir de maintenant : créations, modifications,
          commentaires et documents y seront tracés.
        </div>
      </div>
    );
  }

  // Regroupement par jour : bien plus lisible qu'une liste continue.
  const parJour = {};
  for (const l of lignes) {
    const jour = String(l.created_at).slice(0, 10);
    if (!parJour[jour]) parJour[jour] = [];
    parJour[jour].push(l);
  }

  const nom = (id) => userDisplayName(users.find((u) => u.id === id));

  return (
    <div className="fade-in">
      <p style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginBottom: 14 }}>
        Qui a fait quoi sur ce projet, du plus récent au plus ancien.
      </p>

      {Object.keys(parJour)
        .sort((a, b) => b.localeCompare(a))
        .map((jour) => (
          <div key={jour} style={{ marginBottom: 20 }}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
                color: 'var(--text-muted)',
                marginBottom: 8,
              }}
            >
              {new Date(jour).toLocaleDateString('fr-FR', {
                weekday: 'long', day: '2-digit', month: 'long', year: 'numeric',
              })}
            </div>

            <div className="card" style={{ padding: 0 }}>
              {parJour[jour].map((l, i) => (
                <div
                  key={l.id}
                  style={{
                    display: 'flex',
                    gap: 12,
                    padding: '12px 16px',
                    borderTop: i === 0 ? 'none' : '1px solid var(--border)',
                  }}
                >
                  <div style={{ fontSize: 15, lineHeight: 1.3 }}>{ICONE[l.action] || '•'}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13.5 }}>
                      <strong>{nom(l.user_id)}</strong> {LIBELLE[l.action] || l.action}{' '}
                      <span style={{ color: 'var(--text-secondary)' }}>« {l.cible} »</span>
                    </div>
                    {l.detail && (
                      <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 3, wordBreak: 'break-word' }}>
                        {l.detail}
                      </div>
                    )}
                  </div>
                  <div style={{ fontSize: 11.5, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>
                    {timeAgo(l.created_at)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
}

export default ActivityLog;
